module.exports = __webpack_public_path__ + "img/bessac_bg_05_.384b4912.jpg";